<script setup lang="ts">
import type { ConvinientProps } from '.';
import type { PropertyFilters } from '~/core/entities/property/filters';

import { getConvinientStyles } from './variants';

const props = withDefaults(defineProps<ConvinientProps>(), {
	variant: 'primary'
});

const modelValue = defineModel<
	PropertyFilters['bedrooms' | 'suites' | 'bathrooms' | 'parkingSpots']
>({
	default: 0
});

const convinientsEnum: Record<string, string> = {
	bedrooms: 'Quartos',
	bathrooms: 'Banheiros',
	suites: 'Suítes',
	parkingSpots: 'Vagas'
};

const options: number[] = [0, 1, 2, 3, 4, 5];
const optionsPrefix: string = '+';

const variantStyles = computed(() => getConvinientStyles(props.variant));

function select(option: number): void {
	modelValue.value = modelValue.value === option ? 0 : option;
}

function getVariant(option: number) {
	if (modelValue.value === option) {
		return 'primary';
	}
	return variantStyles.value.inactiveButton;
}

function getLabel(option: number) {
	return option === 0 ? 'Qualquer' : `${optionsPrefix}${option}`;
}
</script>

<template>
	<div class="space-y-2">
		<p :class="variantStyles.label">
			{{ convinientsEnum[props.convinient] }}
		</p>
		<div class="flex items-center gap-2">
			<Button
				v-for="option in options"
				:key="`convinient-select-option-${option}`"
				:variant="getVariant(option)"
				size="sm"
				class="px-3"
				@click="select(option)"
			>
				{{ getLabel(option) }}
			</Button>
		</div>
	</div>
</template>
